import Vue from 'vue'
import { DateTime } from 'luxon'
import { lang } from '@/src/server/helpers/language'

Vue.use({
  install (Vue) {
    Vue.prototype.$filters = Vue.options.filters

    Vue.prototype.$dateTime = DateTime

    // Defining all Luxon Formats as Vue Filters
    const formats = {
      dateTimeFull: DateTime.DATETIME_FULL,
      dateTimeFullWithSeconds: DateTime.DATETIME_FULL_WITH_SECONDS,
      dateTimeHuge: DateTime.DATETIME_HUGE,
      dateTimeHugeWithSeconds: DateTime.DATETIME_HUGE_WITH_SECONDS,
      dateTimeMed: DateTime.DATETIME_MED,
      dateTimeMedWithSeconds: DateTime.DATETIME_MED_WITH_SECONDS,
      dateTimeShort: DateTime.DATETIME_SHORT,
      dateTimeShortWithSeconds: DateTime.DATETIME_SHORT_WITH_SECONDS,
      dateFull: DateTime.DATE_FULL,
      dateHuge: DateTime.DATE_HUGE,
      dateMed: DateTime.DATE_MED,
      dateShort: DateTime.DATE_SHORT,
      time24Simple: DateTime.TIME_24_SIMPLE,
      time24WithLongOffset: DateTime.TIME_24_WITH_LONG_OFFSET,
      time24WithSeconds: DateTime.TIME_24_WITH_SECONDS,
      time24WithShortOffset: DateTime.TIME_24_WITH_SHORT_OFFSET,
      timeSimple: DateTime.TIME_SIMPLE,
      timeWithLongOffset: DateTime.TIME_WITH_LONG_OFFSET,
      timeWithSeconds: DateTime.TIME_WITH_SECONDS,
      timeWithShortOffset: DateTime.TIME_WITH_SHORT_OFFSET,
    }

    for (const format in formats) {
      Vue.prototype.$filters[format] = (value) => {
        return DateTime.fromSQL(value, { zone: 'UTC' })
          .setLocale(lang())
          .toLocal()
          .toLocaleString(formats[format])
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/server/plugins/luxon.js